export default "__VITE_ASSET__DA4Y2iRz__"